module.exports = __webpack_public_path__ + "static/media/IMG-4.32ca33a1.jpg";